// Mega menu Hover change image code Start
document.addEventListener("DOMContentLoaded", function () {
  const promoImg = document.querySelector(".ct-mega-menu-promo-img img.ct-hover-change");
  const originalSrc = promoImg.src;
  const originalSrcset = promoImg.srcset;
  const menuItems = document.querySelectorAll(".ct-mega-menu-title");
  menuItems.forEach((item) => {
    item.addEventListener("mouseenter", function () {
      const img = item.querySelector("img");
      const imgSrc = img.src;
      const imgSrcset = img.srcset;
      promoImg.src = imgSrc;
      promoImg.srcset = imgSrcset;
    });
    item.addEventListener("mouseleave", function () {
      promoImg.src = originalSrc;
      promoImg.srcset = originalSrcset;
    });
  });
});
// Mega menu Hover change image code End

// Get all elements with the class "header__menu-disclosure"
const menuDisclosureItems = document.querySelectorAll(
  ".header__menu-disclosure"
);
menuDisclosureItems.forEach((item) => {
  item.addEventListener("mouseenter", function () {
    this.setAttribute("aria-expanded", "true");
    this.setAttribute("open", "");
    const megaMenu = this.querySelector(".ct-mega-menu-main");
    megaMenu.style.opacity = "1";
  });

  item.addEventListener("mouseleave", function () {
    this.removeAttribute("aria-expanded");
    this.removeAttribute("open");
    const megaMenu = this.querySelector(".ct-mega-menu-main");
    megaMenu.style.opacity = "0";
  });
});

// Get all containers with the class 'ct-dressfolk-sarees-inner'
const containers = document.querySelectorAll(".ct-dressfolk-sarees-inner");
containers.forEach((container) => {
  const tabTitles = container.querySelectorAll(
    ".ct-dressfolk-sarees-coll-heading"
  );
  const tabContents = container.querySelectorAll(
    ".ct-dressfolk-sarees-collection-main"
  );

  tabTitles.forEach((title, index) => {
    title.addEventListener("click", () => {
      // Remove 'is_active' class from all tab titles and contents within this container
      tabTitles.forEach((title) => title.classList.remove("is_active"));
      tabContents.forEach((content) => content.classList.remove("is_active"));

      // Add 'is_active' class to the clicked tab title and corresponding content within this container
      title.classList.add("is_active");
      tabContents[index].classList.add("is_active");
    });
  });
});

// Coupon code js start
// $(document).ready(function() {
//   // Select the elements
//   const $couponHeading = $('.ct-coupon-heading');
//   const $couponMain = $('.ct-coupon-main');

//   // Add click event listener to the coupon heading
//   $couponHeading.on('click', function() {
//     // Toggle the 'is_open' class on the coupon main element
//     $couponMain.toggleClass('is_open');
//   });
// });
// Coupon code js End

var ct_dressfolk_collection = new Swiper(".ct_dressfolk_collection", {
  slidesPerView: "auto",
  spaceBetween: 5,
  pagination: {
    clickable: true,
  },
  navigation: {
    nextEl: ".ct-dressfolk-next",
    prevEl: ".ct-dressfolk-prev",
  },
});

var ct_Loved_customers = new Swiper(".ct_Loved_customers", {
  slidesPerView: "auto",
  spaceBetween: 10,
  pagination: {
    clickable: true,
  },
  navigation: {
    nextEl: ".ct-Loved-custo-next",
    prevEl: ".ct-Loved-custo-prev",
  },
});

// variant change JS start
jQuery(document).ready(function ($) {
  setInterval(displayHello, 1000);

  function displayHello() {
    var uniqueKey = "timestamp_" + Date.now();
    jQuery(".unique_key").val(uniqueKey);
  }
  variantChangeFunction();
  function variantChangeFunction() {
    var selectedSizes = {
      ProductForm_Option_num1: null,
      ProductForm_Option_num2: null,
    };

    function updateSelectedSizes() {
      // Reset selected sizes
      selectedSizes = {
        ProductForm_Option_num1: null,
        ProductForm_Option_num2: null,
      };

      $("input.ct_SizeSwatch_Radio:checked").each(function () {
        var selectedSize = $(this).val();  
        var showSize = '';
        var parentClass = $(this).closest(".ProductForm__Option").attr("class");
        if (parentClass.includes("ProductForm_Option_num1")) {
          selectedSizes["ProductForm_Option_num1"] = selectedSize;
            const sizeMap = {
              XS: ["XS", "S"],
              S: ["XS", "S", "M"],
              M: ["S", "M", "L"],
              L: ["M", "L", "XL"],
              XL: ["L", "XL", "XXL"],
              XXL: ["XL", "XXL"]
            };
            // console.log(selectedSize, " selectedSize");
            if (sizeMap[selectedSize]) {
              const allowedSizes = sizeMap[selectedSize]; 
              // console.log(allowedSizes, " allowedSizes");
              $('.ProductForm_Option_num2 .HorizontalList__Item').each(function () {
                const showValue = $(this).attr('data-show-value'); // Get the data-show-value attribute
                if (allowedSizes.includes(showValue)) {
                  $(this).removeClass("hidden"); // Show the item
                } else {
                  $(this).addClass("hidden"); // Hide the item
                }
              });
            } else {
              console.warn("Selected size not found in sizeMap");
            }
        } else if (parentClass.includes("ProductForm_Option_num2")) {
          selectedSizes["ProductForm_Option_num2"] = selectedSize;
          const sizeMap = {
              XS: ["XS", "S"],
              S: ["XS", "S", "M"],
              M: ["S", "M", "L"],
              L: ["M", "L", "XL"],
              XL: ["L", "XL", "XXL"],
              XXL: ["XL", "XXL"]
            };
            // console.log(selectedSize, " selectedSize");
            if (sizeMap[selectedSize]) {
              const allowedSizes = sizeMap[selectedSize]; 
              // console.log(allowedSizes, " allowedSizes");
              $('.ProductForm_Option_num1 .HorizontalList__Item').each(function () {
                const showValue = $(this).attr('data-show-value'); // Get the data-show-value attribute
                if (allowedSizes.includes(showValue)) {
                  $(this).removeClass("hidden"); // Show the item
                } else {
                  $(this).addClass("hidden"); // Hide the item
                }
              });
            } else {
              console.warn("Selected size not found in sizeMap");
            }
        }
        setTimeout(function(){
             var selectedQuantity = $('.ProductForm_Option_main select option:selected').attr("data-quantity");
                  // console.log(selectedQuantity, " selectedQuantity22");
                if(selectedQuantity < 1 ){
                  $('.ct-quantity-erroe').show();
                  $('.ct-buy-btn button').attr('disabled', true);          
                }
                else{
                  $('.ct-quantity-erroe').hide();
                  $('.ct-buy-btn button').removeAttr('disabled');          
                }
        },1000)
      });
      if (
        selectedSizes["ProductForm_Option_num1"] &&
        selectedSizes["ProductForm_Option_num2"]
      ) {
        var combinedSize =
          selectedSizes["ProductForm_Option_num1"] +
          "/" +
          selectedSizes["ProductForm_Option_num2"];
        updateSelectOption(combinedSize);
        $(".ct-pro-info-buy_buttons").addClass("variant_selected");
      } else if (selectedSizes["ProductForm_Option_num1"]) {
        var singleSize = selectedSizes["ProductForm_Option_num1"];
        updateSelectOption(singleSize);
        $(".ct-pro-info-buy_buttons").addClass("variant_selected");
      } else {
        if (
          $(".ProductForm_Option_num1").length &&
          $(".ProductForm_Option_num2").length
        ) {
          $('.ct-pro-info-buy_buttons input[name="id"]').removeAttr("value");
        }
        $(".ct-pro-info-buy_buttons").removeClass("variant_selected");
      }
    }

    function updateSelectOption(combinedSize) {
      $("select option").each(function () {
        if ($(this).data("sele_value") === combinedSize) {
          $(this).prop("selected", true);
          var selectedValue = $(this).val();
          $('.ct-pro-info-buy_buttons input[name="id"]').val(selectedValue);
          return false; // Break the loop once a match is found
        }
      });
    }

    function showSizeSelectMsg() {
      if (!selectedSizes["ProductForm_Option_num1"]) {
        $(".ProductForm_Option_num1 #SizeSelectMsg").show();
      } else if (
        $(".ProductForm__Option.ProductForm_Option_num2").length &&
        !selectedSizes["ProductForm_Option_num2"]
      ) {
        $(".ProductForm_Option_num2 #SizeSelectMsg").show();
        $(".ProductForm_Option_num1 #SizeSelectMsg").hide();
      } else {
        $(".ProductForm_Option_num2 #SizeSelectMsg").hide();
        $(".ProductForm_Option_num1 #SizeSelectMsg").hide();
      }
    }
    updateSelectedSizes();

    $("input.ct_SizeSwatch_Radio").on("change", function () {
      updateSelectedSizes();
      showSizeSelectMsg();
    });

    // Initial check on page load
    setTimeout(() => {
      $(".ct_SizeSwatch_Radio").removeAttr("checked");
      if (
        $(".ProductForm_Option_num1").length &&
        $(".ProductForm_Option_num2").length
      ) {
        $('.ct-pro-info-buy_buttons input[name="id"]').removeAttr("value");
      } else if ($(".ProductForm_Option_num1").length) {
        $('.ct-pro-info-buy_buttons input[name="id"]').removeAttr("value");
      }

      $(".ct-pro-info-buy_buttons").removeClass("variant_selected");
    }, 1000);

    $(".ct-buy-btn").on("click", function () {
      var sizeSwatchRadio = $("input.ct_SizeSwatch_Radio");
      if (
        sizeSwatchRadio.length > 0 &&
        sizeSwatchRadio.filter(":checked").length === 0
      ) {
        $('.ct-pro-info-buy_buttons input[name="id"]').removeAttr("value");
        $(".ct-pro-info-buy_buttons").removeClass("variant_selected");
        showSizeSelectMsg();
      }
    });

    $(document).on("click", ".icon-quickview", function () {
      setTimeout(() => {
        var parentBlock = $(
          ".product-info__block-item.ct-pro-info-buy_buttons"
        );
        var inputValue = parentBlock.find('input[name="id"]').val();

        $(".ProductForm__LabelLink").on("click", function () {
          const shadowRootWrapper = document.querySelector("quick-buy-modal");
          const shadowRoot = shadowRootWrapper.shadowRoot;
          const innerElement = shadowRoot.querySelector(
            ".ct-quick-view-main-two"
          );
          const parentEle = $(".ct-quick-buy-Vmodal-main").addClass(
            "is_size_open"
          );
        });

        setTimeout(function () {
          var sizeSwatchRadio = $("input.ct_SizeSwatch_Radio");
          if (
            sizeSwatchRadio.length > 0 &&
            sizeSwatchRadio.filter(":checked").length === 0
          ) {
            $('.ct-pro-info-buy_buttons input[name="id"]').removeAttr("value");
            $(".ct-pro-info-buy_buttons").removeClass("variant_selected");
            // showSizeSelectMsg();
          }
          // $('.ct-pro-info-buy_buttons input[name="id"]').removeAttr("value");
        }, 1000);
        variantChangeFunction();
        openSizeChart();
      }, 2000);
    });
  }
});
// variant change JS End

// Size chart open code Start
openSizeChart();
function openSizeChart() {
  // Get the button and the modal elements
  var openModalButton = document.querySelector(".ProductForm__LabelLink");
  var modal = document.querySelector(".Product__OffScreen");
  var closeButton = document.querySelector(".close-button");

  openModalButton &&
    modal &&
    openModalButton.addEventListener("click", function (e) {
      modal.style.display = "block";
      modal.classList.add("open");
    });

  // Add click event listener to the close button
  closeButton &&
    closeButton.addEventListener("click", function () {
      closeDrawer();
    });

  // Add event listener to close the modal when clicking outside of it
  window.addEventListener("click", function (event) {
    if (event.target === modal) {
      closeDrawer();
    }
  });

  function closeDrawer() {
    modal.classList.remove("open");
    setTimeout(function () {
      $(".ct-quick-buy-Vmodal-main").removeClass("is_size_open");
    }, 500);

    const modalContent = $(".quick-buy-modal::part(content)");
    if (modalContent.length) {
      modalContent.css("overflow", "auto");
    }
    setTimeout(function () {
      modal.style.display = "none";
    }, 500);
  }
}
// Size chart open code End
// product Offer swiper code start
function offer_slider() {
  var slideCount = document.querySelectorAll(
    ".offer_sale .swiper-slide"
  ).length;

  if (slideCount > 1) {
    var loopEnabled = slideCount >= 3; // Enable loop only if there are 3 or more slides
    var centeredSlidesEnabled = slideCount >= 3; // Enable centeredSlides only if there are 3 or more slides
    var offer_sale = new Swiper(".offer_sale", {
      slidesPerView: 1.3,
      centeredSlides: centeredSlidesEnabled,
      spaceBetween: 15,
      loop: loopEnabled,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
    // Make sure the second slide is active on document ready
    if (slideCount >= 3) {
      offer_sale.slideTo(2, 0); // Move to the second slide (index 1) immediately with no transition (0 ms)
    }
  }
}
$(document).ready(function () {
  offer_slider();
});
// product Offer swiper code end


// PDP Menu open code js start
$(document).ready(function () {
  const $menuHeading = $(".ct-header-nav-pdp-btn");
  const $menuMain = $(".ct-header-nav-pdp");
  const $menuclose = $(".ct-header-nav-pdp .ct-pdp-menu-close");
  $menuHeading.on("click", function () {
    $menuMain.addClass("is_open");
  });
  $menuclose.on("click", function () {
    $menuMain.removeClass("is_open");
  });
});

$(document).on("click", ".ct_menu_Suit, .ct_menu_Blouse, .ct_menu_Saree", function () {
    const clickedClass = [...$(this).attr("class").split(" ")].find(cls => cls.startsWith("ct_menu_"));
    // console.log(clickedClass);
    const targetClass = clickedClass.replace("ct_menu_", "ct_mmenu_");
    // console.log(targetClass);
    $('.ct-product-page .ct-header-nav-mob-main').show();
    $(`.${targetClass}`).trigger('click');
});
// PDP Menu open code js End

// Search function sticky code start
$(document).on("click", ".ct-search-hmain", function () {
    $('html').css({
      'overflow': 'inherit'
    });
  const headerSearch = document.querySelector('header-search');
  if (headerSearch) {
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          if (headerSearch.hasAttribute('open')) {
            $('html').css({
              'overflow': 'inherit'
            });
          } else {
            $('html').css({
              'overflow': ''
            });
          }
        }
      });
    });
    observer.observe(headerSearch, { attributes: true });
    $(document).on("click", ".ct-search-close", function () {
      $('html').css({
        'overflow': ''
      });
      console.log("Observer disconnected");
    });
  } else {
    console.error("header-search element not found");
  }
});
// Search function sticky code End

// Pair with the ready made blouse variant sold out js Start
$(document).on('click', '.ct-pair-variant-main .variant-select', function () {
    if ($(this).hasClass('soldout')) {
        $('.ct-pamb-size-inner .ct-quantity-erroe').show();
        $('.ct-pamb-size-inner .ct-buy-btn button').attr('disabled', 'disabled');
    } else {
        $('.ct-pamb-size-inner .ct-quantity-erroe').hide();
        $('.ct-pamb-size-inner .ct-buy-btn button').removeAttr('disabled');
    }
});
// Pair with the ready made blouse variant sold out js End